import { Application, Assets } from 'pixi.js';
import { GameState, SaveData } from './GameState';
import { GameLoop } from '@shared/idle-core/GameLoop';
import { SaveManager } from '@shared/save-system/SaveManager';
import { SceneManager } from '@shared/engine/SceneManager';
import { GameplayScene } from './scenes/GameplayScene';
import { ALL_SPRITE_PATHS } from './config/assets';

const GAME_ID = 'cacador-da-amazonia';
const SAVE_KEY = 'gameState-v2'; // v2 para não conflitar com save antigo

async function init() {
  const app = new Application();
  await app.init({
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x1a472a,
    resizeTo: window,
    antialias: true,
  });
  document.body.appendChild(app.canvas);

  // Preload sprites
  await Assets.load(ALL_SPRITE_PATHS);
  console.log('[Cacador] Sprites carregados:', ALL_SPRITE_PATHS.length);

  // Save system
  const saveManager = new SaveManager(GAME_ID);
  const savedData = await saveManager.load<SaveData>(SAVE_KEY);
  const gameState = savedData ? GameState.fromSave(savedData.data) : GameState.createNew();

  // Scene manager — apenas 1 cena
  const sceneManager = new SceneManager(app);
  sceneManager.add('gameplay', new GameplayScene(app, gameState));
  sceneManager.switchTo('gameplay');

  // Game loop
  const gameLoop = new GameLoop(60, (dt: number) => {
    sceneManager.update(dt);
  });

  // Auto-save
  saveManager.startAutoSave(SAVE_KEY, () => gameState.toSave(), 30000);
  window.addEventListener('beforeunload', () => {
    saveManager.save(SAVE_KEY, gameState.toSave());
  });

  gameLoop.start();
  console.log('[Cacador da Amazonia] Jogo iniciado! (v2 — sprites + fadiga)');
}

init().catch(console.error);
